(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('ProfilePublicController', ProfilePublicController);

    ProfilePublicController.$inject = ['$scope', '$stateParams', 'entity', 'Principal', 'Connexion', 'Picture', 'Position'];

    function ProfilePublicController($scope, $stateParams, entity, Principal, Connexion, Picture, Position) {
        var vm = this;
        vm.isAdmin = isAdmin;

        vm.hideProfileCard =true;
        vm.profile = entity;

        loadPicture(vm.profile);
        vm.isDG = false;
        Principal.profile().then(function (profile) {
            vm.myProfile = profile;
        });
        vm.connexion = {};
        vm.updateGrade = updateGrade;

        
        vm.fullName = vm.profile.firstName + ' ' + vm.profile.lastName;

        if ($stateParams.position){
            vm.selectedPosition = vm.profile.positions.find(function (p) {
                return p.id === parseInt($stateParams.position);
            });
        } else {
            vm.selectedPosition = vm.profile.currentPosition;
        }

        vm.websiteForOrganisation = websiteForOrganisation;
        vm.websiteGuidePouvoir = websiteGuidePouvoir(vm.profile);
        vm.websiteDataGouv = websiteDataGouv;

        vm.clipTooltip = 'Cliquez pour copier dans le presse papier';
        vm.copied = copied;
        //vm.selectedPosition = vm.profile.currentPosition? vm.profile.currentPosition : {};


        vm.organisations = vm.profile.positions.map(function(position){
            return position.organisation;
        });

        vm.organisation = vm.selectedPosition && vm.selectedPosition.organisation && vm.selectedPosition.organisation.id ?
            vm.selectedPosition.organisation : {};

        Principal.hasAuthority('ROLE_DG').then(function (isDG) {
            vm.isDG = isDG;
        });
        setConnexion();

        function isAdmin() {
            return Principal.hasAnyAuthority(['ROLE_ADMIN']);
        }

        function setConnexion() {
            $scope.profileCardBusyPromise = Connexion.search({
                query: vm.profile.lastName
            }, function (connexions) {
                var relevantConnexions = connexions.filter(function (connexion) {
                    return connexion.target.id === vm.profile.id || connexion.creator.id === vm.profile.id
                });
                if (relevantConnexions.length) {
                    vm.connexion = relevantConnexions[0];
                }
                setTimeout(function(){ vm.hideProfileCard = false;}, 0);

            }).$promise;
        }

        function updateGrade(newGrade) {
            if (vm.connexion.id) {
                Connexion.update({
                    id: vm.connexion.id,
                    grade: newGrade,
                    target: vm.connexion.target,
                    creator: vm.connexion.creator
                }, function (connexion) {
                    vm.connexion = connexion;
                });
            } else {
                Connexion.create({
                    grade: newGrade,
                    target: vm.profile,
                    creator: vm.myProfile
                }, function (connexion) {
                    vm.connexion = connexion;
                });
            }
        }

        function loadPicture(profile){
            if (profile.pictureContentType){
                Picture.getProfilePicture(profile.id).then(function (response) {
                    profile.picture=response;
                }, function (response) {
                    console.log(response);
                });
            }
        }

        function websiteForOrganisation(selectedPosition) {
            var website = selectedPosition ? selectedPosition.organisation.website : null;
            if (website && !website.includes('http')) {
                return 'https://' + website;
            } else {
                return website;
            }
        }
        function websiteGuidePouvoir(profile) {
            if (profile.domain && profile.domain === 'guidep') {
                return  'https://www.leguidedupouvoir.fr/page/personnalite_entite/'+ profile.importId + '/index.htm';
            } else {
                return null;
            }
        }

        function websiteDataGouv(selectedPosition) {
            if (selectedPosition && selectedPosition.organisation.type === 'collectivity') {
                return  'https://www.data.gouv.fr/fr/datasets/repertoire-national-des-elus-1/';
            } else {
                return null
            }
        }

        function copied() {
            vm.clipTooltip = 'Copié !';
            setTimeout(function() {
                vm.clipTooltip = 'Cliquez pour copier dans le presse papier';
            }, 3000);
        }
    }
})();
